import { Pipe, PipeTransform } from '@angular/core';

import { OaPopulationStatus } from '../models/oa.model';

@Pipe({
    name: 'oapopulationstatus',
})
export class OaPopulationStatusPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    transform(type: OaPopulationStatus) {
        // switch(type) {
        //     case OaPopulationStatus.COMPLETE:
        //     return 'Full';
        //     case OaPopulationStatus.PARTIAL:
        //     return 'Partial';
        //     case OaPopulationStatus.PARTIAL_NO_OA:
        //     return 'Partial No OA';
        //     default:
        //         return 'No OA';
        // }
    }
}
